import './lib/lazyload';
import intersect from '@alpinejs/intersect';
import { DataLayer } from './services/datalayer';
import './services/rgpd-cookies';
import { createApp } from './utils/alpine';
import datalayer from './plugins/datalayer';
import obfuscatedLink from './plugins/obfuscated-link';
import { Banner } from './partials/banner';
import { Pagination } from './partials/pagination';
import { Navigation } from './partials/navigation';
import { New } from './partials/new';
import { Newsletter } from './partials/newsletter';
import { Address } from './components/address';
import { Datepicker } from './components/datepicker';
import { Partners } from './components/partners';
import { Sliders } from './components/sliders';
import { Toggler } from './components/toggler';
import { Contact } from './modules/contact';
import { Callback } from './modules/callback';
import { Sample } from './modules/sample';
import { Facets } from './modules/facets';
import { Product } from './modules/product';
import { HandleBrief } from './modules/brief';
import { Quote } from './modules/quote';
import { Users } from './modules/users';
import { Wishlist } from './modules/wishlist';
import './modules/tagging';
createApp({
    Components: {
        Address,
        Datepicker,
        Partners,
        Sliders,
        Toggler,
    },
    Modules: {
        HandleBrief,
        Contact,
        Callback,
        Sample,
        Facets,
        Product,
        Quote,
        Users,
        Wishlist,
    },
    Partials: {
        Banner,
        Navigation,
        Pagination,
        New,
        Newsletter,
    },
}, [intersect, obfuscatedLink, datalayer]);
DataLayer.init();
